
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.905.852a4.051 4.051 0 00-3.851 2.79 4.002 4.002 0 00-2.67 1.935 4.026 4.026 0 00.5 4.724 3.966 3.966 0 00.341 3.267 4.048 4.048 0 004.35 1.94 3.997 3.997 0 003.006 1.344 4.053 4.053 0 003.853-2.79 3.983 3.983 0 002.664-1.935 4.019 4.019 0 00-.494-4.725v-.005a3.98 3.98 0 00-.342-3.273 4.049 4.049 0 00-4.345-1.934A4.016 4.016 0 007.905.852zm0 1.04l-.005.005c.705 0 1.383.243 1.926.694-.023.01-.066.038-.098.054l-3.19 1.837a.518.518 0 00-.26.455v4.312l-1.373-.79V4.892c0-1.655 1.342-2.999 3-3.002zm3.843 1.255a3.004 3.004 0 012.966 3.508c-.023-.016-.065-.038-.093-.054l-3.19-1.843a.535.535 0 00-.525 0L7.168 6.915V5.332l3.086-1.782c.454-.263.969-.402 1.494-.403zm-7.89 1.638V8.57c0 .19.097.358.26.455l3.732 2.15-1.378.797-3.081-1.777a2.998 2.998 0 01.467-5.411zm7.15.938L14.095 7.5a2.992 2.992 0 011.095 4.095l.006.006a2.996 2.996 0 01-1.562 1.311V9.125a.518.518 0 00-.26-.455L9.636 6.513l1.372-.79zM8.741 7.028l1.573.91v1.815l-1.573.91-1.574-.91V7.938l1.574-.91zm2.473 1.43l1.373.791v3.56a3.003 3.003 0 01-3 3.002v-.005c-.7 0-1.384-.245-1.92-.694l.097-.054 3.19-1.837a.508.508 0 00.26-.455V8.458zm-.895 2.33v1.583l-3.087 1.777a3.01 3.01 0 01-4.101-1.095h.005a2.973 2.973 0 01-.359-2.004c.023.016.066.038.093.054l3.189 1.842a.535.535 0 00.526 0l3.734-2.157z","fill":"#748190"}})])
          )
        }
      }
    